module.exports = __webpack_public_path__ + "img/luxuryyacht_main_02.37e1812c.jpg";